module.exports = __webpack_public_path__ + "static/img/tab_1.dd16979.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/ani-event/home/tab_1.png
// module id = fUI7
// module chunks = 1